import { useMemo } from 'react';
import { useGetAllChainedStrategiesExpandedQuery } from 'src/api/redux';

interface ChainInfo {
  id: number;
  label: string;
}

type ChainMap = Map<number, ChainInfo[]>;

/**
 * Builds a lookup map from strategy ID → chain(s) that reference it.
 * Used by Target and Engage strategy grids to show chain associations.
 *
 * TODO: Replace useGetAllChainedStrategiesExpandedQuery with
 * useGetAllChainedStrategiesQuery once BE includes target_strategy/engage_strategies
 * in the list response.
 */
export function useChainMap(type: 'target' | 'engage'): ChainMap {
  const { data: chainsData } = useGetAllChainedStrategiesExpandedQuery();

  return useMemo(() => {
    const map = new Map<number, ChainInfo[]>();
    if (!chainsData?.results) return map;

    chainsData.results.forEach((chain: any) => {
      if (type === 'target') {
        const targetId =
          typeof chain.target_strategy === 'object'
            ? chain.target_strategy?.id
            : chain.target_strategy;
        if (targetId) {
          const existing = map.get(targetId) || [];
          existing.push({ id: chain.id, label: chain.label });
          map.set(targetId, existing);
        }
      } else {
        if (chain.engage_strategies) {
          chain.engage_strategies.forEach((engageStrategy: any) => {
            const engageId =
              typeof engageStrategy === 'object'
                ? engageStrategy.id
                : engageStrategy;
            if (engageId) {
              const existing = map.get(engageId) || [];
              existing.push({ id: chain.id, label: chain.label });
              map.set(engageId, existing);
            }
          });
        }
      }
    });

    return map;
  }, [chainsData, type]);
}
